import moment from "moment";
import apis from "../../../../api";
import { downloadFile } from "../../../../utils/downloadFile";
import { errorTypes } from "../../../../utils/errorTypes";
import loaders from "../../actionCreators/loadersActionCreator";
import { setErrorHandler } from "../errorActionHandler";

export const getAllNotificationsActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setUsersData,
    setTempUsersData,
    setTotalRows
  ) =>
  async () => {
    await apis.admin.engagementCenter
      .getAllNotifications(searchText, pageNumber, pageSize)
      .then((response) => {
        setUsersData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTempUsersData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTotalRows(response?.data?.TotalRows);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const triggerNotificationActionHandler = (data) => async (dispatch) => {
  dispatch(loaders.admin.engagementCenter.triggerNotificationLoader(true));
  return await apis.admin.engagementCenter
    .triggerNotification(data)
    .then((response) => {
      if (response.status === 200) {
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            `Your Request has been initiated.`
          )
        );
      }
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(loaders.admin.engagementCenter.triggerNotificationLoader(false));
    });
};

export const deleteNotificationActionHandler =
  (notificationId) => async (dispatch) => {
    dispatch(loaders.admin.engagementCenter.deleteNotificationLoader(true));
    return await apis.admin.engagementCenter
      .deleteNotification(notificationId)
      .then((response) => {
        if (response.data) {
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              "Notification Deleted Successfully."
            )
          );
        }
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(
          loaders.admin.engagementCenter.deleteNotificationLoader(false)
        );
      });
  };

export const getAllNotificationHistoryActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setUsersData,
    setTempUsersData,
    setTotalRows,
    from,
    to
  ) =>
  async () => {
    await apis.admin.engagementCenter
      .getAllNotificationHistory(searchText, pageNumber, pageSize, from, to)
      .then((response) => {
        setUsersData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTempUsersData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTotalRows(response?.data?.TotalRows);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getNotificationHistoryCSVActionHandler =
  (notificationId, NotificationDistributionLogId) => async (dispatch) => {
    // dispatch(loaders.admin.userManagement.getCountryListLoader(true));
    return await apis.admin.engagementCenter
      .getNotificationHistoryCSV(notificationId, NotificationDistributionLogId)
      .then((response) => {
        const fileName = `Export_${moment().format("DMMMYYYY_hhmmss")}`;
        downloadFile(response.data, fileName);
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      });
    // .finally(() => {
    //   dispatch(loaders.admin.userManagement.getCountryListLoader(false));
    // });
  };

export const getNotificationByIdActionHandler =
  (notificationId) => async (dispatch) => {
    dispatch(loaders.common.pageLoader(true));
    return await apis.admin.engagementCenter
      .getNotificationById(notificationId)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.common.pageLoader(false));
      });
  };
export const getNotificationModeActionHandler = () => async (dispatch) => {
  return await apis.admin.engagementCenter
    .getNotificationMode()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {});
};
export const getNotificationTemplateActionHandler = () => async (dispatch) => {
  return await apis.admin.engagementCenter
    .getNotificationTemplate()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {});
};
export const getNotificationTypeActionHandler = () => async (dispatch) => {
  return await apis.admin.engagementCenter
    .getNotificationType()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {});
};
export const getNotificationFrequencyActionHandler = () => async (dispatch) => {
  return await apis.admin.engagementCenter
    .getNotificationFrequency()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {});
};
export const getNotificationPlaceholdersActionHandler =
  () => async (dispatch) => {
    return await apis.admin.engagementCenter
      .getNotificationPlaceholders()
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {});
  };
export const getPlaceHolderEventsActionHandler = () => async (dispatch) => {
  return await apis.admin.engagementCenter
    .getPlaceHolderEvents()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {});
};
export const getNotificationEventActionHandler =
  (notificationTypeId) => async (dispatch) => {
    return await apis.admin.engagementCenter
      .getNotificationEvent(notificationTypeId)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {});
  };
export const getNotificationEventValuesActionHandler =
  (eventId) => async (dispatch) => {
    return await apis.admin.engagementCenter
      .getNotificationEventValues(eventId)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {});
  };
export const getPlaceholderEventValuesActionHandler =
  (eventId) => async (dispatch) => {
    return await apis.admin.engagementCenter
      .getPlaceholderEventValues(eventId)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {});
  };
export const getLandingPagesActionHandler = () => async (dispatch) => {
  return await apis.admin.engagementCenter
    .getLandingPages()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {});
};
export const updateNotificationActionHandler = (data) => async (dispatch) => {
  return await apis.admin.engagementCenter
    .updateNotification(data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {});
};
